import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'antd';
import { MESSAGES } from '@translations/labels';
import DSPage from '@design-system/page/DSPage';
import { useAgentId } from '@hooks/useAgentId';
import vdnSettingsActions from '@store/actions/vdnSettings';

import { ManageBotHeader } from '../manageBotHeader';
import { VdnSettingsForm } from './forms/vdnSettingsForm';
import { VdnVersionSelector } from './components/vdnVersionSelector';
import { openSaveVdnVersionModal } from './components/saveVdnVersionModal';

import releasesPageStyles from './vdnSettingsPageStyles';

const labels = { ...MESSAGES.commons, ...MESSAGES.manageBot.releasesPage };

const VDNSettingsPage = () => {
  const dispatch = useDispatch();
  const { agentId } = useAgentId();
  const versions = useSelector(state => state.vdnSettings.versions);
  const [selectedVersionId, setSelectedVersionId] = useState(undefined);

  useEffect(() => {
    dispatch(vdnSettingsActions.getVdnVersions(agentId));
  }, [agentId]);

  // Auto-select the latest version on initial load
  useEffect(() => {
    if (versions.length > 0 && selectedVersionId === undefined) {
      const latestVersion = versions[0];
      setSelectedVersionId(latestVersion._id);
      dispatch(vdnSettingsActions.loadVdnVersion(agentId, latestVersion._id));
    }
  }, [versions]);

  const handleChangeVersion = (versionId) => {
    setSelectedVersionId(versionId);
    if (versionId) {
      dispatch(vdnSettingsActions.loadVdnVersion(agentId, versionId));
    }
  };

  const handleSave = (parsedJson) => {
    openSaveVdnVersionModal((versionName, versionDescription) => {
      dispatch(vdnSettingsActions.updateVdnSettings(agentId, parsedJson, versionName, versionDescription, (newVersionId) => {
        setSelectedVersionId(newVersionId);
      }));
    });
  };

  return (
    <div className="manage-bot-content last-training overflow-y-auto">
      <ManageBotHeader />
      <DSPage>
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <header className="header-release-page" style={{ marginBottom: 0 }}>
              <h4 className="uppercase">{labels.vdnSettings}</h4>
            </header>
          </Col>
          <Col>
            <VdnVersionSelector
              versions={versions}
              selectedVersionId={selectedVersionId}
              onChangeVersion={handleChangeVersion}
            />
          </Col>
        </Row>
        <VdnSettingsForm onSave={handleSave} />
      </DSPage>
      <style jsx>{releasesPageStyles}</style>
    </div>
  );
};

export { VDNSettingsPage };